import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parses a date-only value (SQL DATE column, e.g. "2026-08-28") into a Date
 * anchored to LOCAL midnight, avoiding the off-by-one-day shift caused by
 * `new Date("2026-08-28")` treating the string as UTC midnight.
 */
export function parseDateOnly(value: string | Date): Date {
  if (value instanceof Date) {
    // Neon serverless returns DATE as a string, but guard for Date objects too.
    return new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate())
  }
  const [year, month, day] = value.slice(0, 10).split("-").map(Number)
  return new Date(year, (month ?? 1) - 1, day ?? 1)
}

/** Formats a date-only value without any timezone shift. */
export function formatDateOnly(
  value: string | Date,
  options: Intl.DateTimeFormatOptions = { weekday: "long", year: "numeric", month: "long", day: "numeric" },
): string {
  return parseDateOnly(value).toLocaleDateString("en-US", options)
}
